import React, { createContext, useState, useEffect } from "react";
import en from "../data/en.json";
import pt from "../data/pt-br.json";
import es from "../data/es.json";
import fr from "../data/fr.json";
import zh from "../data/zh.json";
import de from "../data/de.json";
import it from "../data/it.json";
import ja from "../data/ja.json";
import ru from "../data/ru.json";
import nl from "../data/nl.json";

export const LanguageContext = createContext({
  language: "en",
  setLanguage: () => {},
  translations: en,
});

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState("en");
  const [translations, setTranslations] = useState(en);

  useEffect(() => {
    switch (language) {
      case "en":
        setTranslations(en);
        break;
      case "pt":
        setTranslations(pt);
        break;
      case "es":
        setTranslations(es);
        break;
      case "fr":
        setTranslations(fr);
        break;
      case "zh":
        setTranslations(zh);
        break;
      case "de":
        setTranslations(de);
        break;
      case "it":
        setTranslations(it);
        break;
      case "ja":
        setTranslations(ja);
        break;
      case "ru":
        setTranslations(ru);
        break;
      case "nl":
        setTranslations(nl);
        break;
      default:
        setTranslations(en);
    }

  }, [language]);

  return (
    <LanguageContext.Provider value={{ language, setLanguage, translations }}>
      {children}
    </LanguageContext.Provider>
  );
};
